import { SCHEDULER_LABEL_CLASS, SCHEDULER_SELECT_CLASS } from '../CustomTableViews/schedulerFieldClasses';

// What the API lets a report's tab be named, which this name also becomes.
const REPORT_NAME_MAX_LENGTH = 255;

export interface ReportNameFieldProps {
  id: string;
  value: string;
  disabled: boolean;
  onChange: (name: string) => void;
}

/** The name a report's email subject and the Reports page show it by. */
export const ReportNameField = ({ id, value, disabled, onChange }: ReportNameFieldProps) => (
  <div className="mb-3">
    <label
      htmlFor={id}
      className={SCHEDULER_LABEL_CLASS}>
      Report Name
    </label>
    <input
      id={id}
      type="text"
      className={`${SCHEDULER_SELECT_CLASS} w-full`}
      placeholder="e.g. Weekly Order Pipeline"
      value={value}
      maxLength={REPORT_NAME_MAX_LENGTH}
      aria-required="true"
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);
